export function parseSpecificUserRows(rows) {
  const entries = rows
    .map((row, index) => ({ uid: String(row[0] ?? "").trim(), row: index + 1 }))
    .filter(entry => entry.uid)

  const header = entries[0]?.uid.toLowerCase().replace(/[\s_-]/g, "")
  if (["lineuid", "lineuserid", "lineuseruid"].includes(header)) entries.shift()
  if (!entries.length) throw new Error("The uploaded file does not contain any LINE user IDs.")

  const invalid = entries.find(entry => !/^U[0-9a-f]{32}$/.test(entry.uid))
  if (invalid) {
    throw new Error(`Invalid LINE user ID in row ${invalid.row}. Each ID must start with U followed by 32 lowercase hexadecimal characters.`)
  }
  return [...new Set(entries.map(entry => entry.uid))]
}

export function normalizeCampaignContentBlocks(blocks) {
  return (blocks || []).filter(block => {
    if (!block || !["text", "image", "pictures"].includes(block.type || "text")) return true
    return Object.entries(block).some(([key, value]) => {
      if (["id", "type"].includes(key)) return false
      return typeof value === "string" ? !!value.trim() : !!value
    })
  }).map(block => {
    if (!block || typeof block !== "object") return block
    return { ...block, type: block.type === "pictures" ? "image" : (block.type || "text") }
  })
}

export function getSurveyEntryChannel(surveyUrl, campaignId, surveyUuidLink) {
  try {
    const url = new URL(surveyUrl)
    const channels = url.searchParams.getAll("entry_channel")
    const campaigns = url.searchParams.getAll("lcid")
    const expectedPath = `/pdpa/chat/${surveyUuidLink}`
    if (!["http:", "https:"].includes(url.protocol) || url.username || url.password ||
        url.pathname.replace(/^\/webchat\//, "/pdpa/chat/") !== expectedPath ||
        campaigns.length !== 1 || campaigns[0] !== String(campaignId) ||
        channels.length !== 1 || !["line_man", "grab"].includes(channels[0])) return ""
    return channels[0]
  } catch {
    return ""
  }
}
